"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _NotificationItem = require("./NotificationItem");

var _NotificationItem2 = _interopRequireDefault(_NotificationItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NotificationList = (_temp = _class = function (_Component) {
  _inherits(NotificationList, _Component);

  function NotificationList() {
    _classCallCheck(this, NotificationList);

    return _possibleConstructorReturn(this, (NotificationList.__proto__ || Object.getPrototypeOf(NotificationList)).apply(this, arguments));
  }

  _createClass(NotificationList, [{
    key: "handleDismiss",
    value: function handleDismiss(id) {
      var onDismiss = this.props.onDismiss;

      if (onDismiss) {
        onDismiss(id);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var notifications = this.props.notifications;

      return _react2.default.createElement(
        "div",
        { className: "erg-components-NotificationList" },
        notifications.map(function (_ref) {
          var bsStyle = _ref.bsStyle,
              id = _ref.id,
              message = _ref.message,
              time = _ref.time,
              title = _ref.title;
          return _react2.default.createElement(_NotificationItem2.default, {
            bsStyle: bsStyle,
            key: id,
            message: message,
            onDismiss: _this2.handleDismiss.bind(_this2, id),
            time: time,
            title: title });
        })
      );
    }
  }]);

  return NotificationList;
}(_react.Component), _class.displayName = "NotificationList", _class.propTypes = {
  notifications: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    /* eslint-disable react/no-unused-prop-types */
    bsStyle: _propTypes2.default.string,
    id: _propTypes2.default.string.isRequired,
    message: _propTypes2.default.string.isRequired,
    title: _propTypes2.default.string.isRequired,
    time: _propTypes2.default.number
    /* eslint-enable react/no-unused-prop-types */
  })).isRequired,
  onDismiss: _propTypes2.default.func
}, _temp);
exports.default = NotificationList;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@ergeon/erg-components-react/lib/NotificationList.js
 ** module id = 787
 ** module chunks = 0
 **/